function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import EdenImage from "@churchofjesuschrist/eden-image";
import { spacing32 } from "@churchofjesuschrist/eden-style-constants";
const ImageStyled = styled(EdenImage).withConfig({
  componentId: "sc-icpdtt-0"
})(["margin-block-start:", ";margin-block-end:", ";"], spacing32, spacing32);

const Image = _ref => {
  let {
    src,
    alt,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ImageStyled, _extends({
    src,
    alt
  }, props));
};

Image.propTypes = {
  /* Image source */
  src: PropTypes.string,

  /* Image alt text */
  alt: PropTypes.string
};
export default Image;